import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { Typography } from '@snack-uikit/typography';
import styles from "./styles.module.css";
import { getValueTypographyProps } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BenefitItem(_ref) {
  var value = _ref.value,
    description = _ref.description,
    layoutType = _ref.layoutType;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.benefitItem,
    "data-layout-type": layoutType,
    children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
      family: "sans",
      tag: "div"
    }, getValueTypographyProps(layoutType)), {}, {
      children: /*#__PURE__*/_jsx(RichText, {
        richText: value
      })
    })), /*#__PURE__*/_jsx(Typography, {
      family: "sans",
      tag: "div",
      purpose: "title",
      size: "m",
      children: /*#__PURE__*/_jsx(RichText, {
        richText: description
      })
    })]
  });
}